var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Typography from '@mui/material/Typography';
import React, { useCallback, useMemo } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { emptyList, useApiFetch } from '../Api';
import useApiAbort from '../Api/Core/useApiAbort';
import { Features, hasPermission } from '../Auth/Features';
import { useApi } from '../Context/APIContext';
import { useUserContext } from '../Context/UserContext';
import { useStyles } from './MyPages.styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircleRounded';
import CreditCardIcon from '@mui/icons-material/CreditCardRounded';
import AddIcon from '@mui/icons-material/AddRounded';
import Transition from '../Components/Transition';
import Wrapper from '../Components/Wrapper';
import Box from '@mui/material/Box';
import ButtonCard from '../Components/ButtonCard';
import IconCard from '../Components/ButtonCard/IconCard';
import Storage from '../Components/ButtonCard/Storage';
import { getAppRoutes } from '../Config';
const fetchStorages = (api, navigate) => __awaiter(void 0, void 0, void 0, function* () {
    if (api) {
        const response = yield api.getRentals();
        if (!response) {
            navigate('/login');
        }
        const storages = [...response.storages];
        const uniqueList = [];
        storages.forEach(s => {
            if (uniqueList.every(x => x.rentalId !== s.rentalId)) {
                uniqueList.push(s);
            }
        });
        return uniqueList;
    }
    else {
        return [];
    }
});
export const MyPages = () => {
    const classes = useStyles();
    const api = useApi();
    const abortController = useApiAbort();
    if (api) {
        api.setAbortController(abortController.current);
    }
    const { user, loggedIn } = useUserContext();
    const navigate = useNavigate();
    const canViewMyStorages = useMemo(() => hasPermission(Features.viewMyStorages, user), [user]);
    const canViewSubscriptions = useMemo(() => hasPermission(Features.viewSubscriptions, user), [user]);
    const [storages] = useApiFetch(useCallback(() => fetchStorages(api, navigate), [api, navigate]), undefined, emptyList, abortController.current);
    const routes = getAppRoutes();
    useEffect(() => {
        if (!loggedIn) {
            navigate('/login');
        }
    }, [loggedIn, navigate]);
    return (React.createElement(Transition, { isLoading: user === undefined || storages === undefined },
        React.createElement(Typography, { variant: "h1", sx: classes.title }, "Mina sidor"),
        React.createElement(Box, { component: "div", sx: classes.outerContainer },
            React.createElement(Box, { component: "section", sx: classes.container },
                React.createElement(Wrapper, null,
                    React.createElement(Typography, { component: "h2", variant: "h5", sx: classes.wrapperTitle }, "\u00D6versikt"),
                    React.createElement(Box, { component: "section", sx: classes.root },
                        canViewSubscriptions && user && user.role.id === 'Customer' && (React.createElement(ButtonCard, { to: "/mypages/mypayments", children: React.createElement(IconCard, { icon: React.createElement(CreditCardIcon, null), title: "Betalningar" }) })),
                        React.createElement(ButtonCard, { to: "/mypages/account", children: React.createElement(IconCard, { icon: React.createElement(AccountCircleIcon, null), title: "Kontouppgifter" }) }))),
                canViewMyStorages && (React.createElement(Wrapper, null,
                    React.createElement(Typography, { component: "h2", variant: "h5", sx: classes.wrapperTitle }, "Mina utrymmen"),
                    React.createElement(Box, { component: "section", sx: classes.root },
                        storages &&
                            storages.map((storage) => (React.createElement(ButtonCard, { key: `${storage.rentalId}_${storage.ownerFirstName}`, to: `/mypages/mystorage/${storage.storageId}`, children: React.createElement(Storage, { containerCode: storage.containerCode, storageCode: storage.storageCode, facilityName: storage.facilityName, facilityLevel: storage.facilityLevel, rentedBy: storage.isShared &&
                                        (storage.subscriptionId === undefined ||
                                            storage.subscriptionId === null)
                                        ? `${storage.ownerFirstName} ${storage.ownerLastName}`
                                        : undefined, startDate: !storage.rentalStarted ? storage.startDate : undefined, volume: storage.volume }) }))),
                        React.createElement(ButtonCard, { toExternal: `${routes.booking}#/order`, children: React.createElement(IconCard, { icon: React.createElement(AddIcon, null), title: "L\u00E4gg till utrymme" }) }))))))));
};
